import { useRouter } from 'next/router';

import { Typography, Box, Container } from '@mui/material';
import CircleRoundedIcon from '@mui/icons-material/CircleRounded';
import Image from 'next/image';

import { useStyles } from './useStyles';

interface IReceipesComponent {
  pages: any;
  pageType: string;
}

const ReceipesComponent = ({ pages, pageType }: IReceipesComponent) => {
  const lastFourPages = pages ? pages.slice(-4) : [];

  const router = useRouter();
  const classes = useStyles();

  const SECOND_VARIATION = 'heroSectionWithTurmericBackground';

  const handleClickCard = (uid: string) => {
    router.push(`/${uid}`);
  };

  return (
    <Box className={classes.mainContainer}>
      <Container maxWidth="xl" disableGutters className={classes.container}>
        <Box className={classes.itemContainer}>
          <Typography
            variant="h3"
            align="center"
            color="cinnamon.main"
            mb="45px"
          >
            Latest Recipes
          </Typography>
          <Box className={classes.dishWrapper}>
            {lastFourPages.map((item: any) => {
              const { primary, variation } = item?.data?.slices[0] || {};
              const { dish_name, by_whom, dish_image } = primary || {};
              if (dish_image?.url) {
                return (
                  <Box
                    key={item.id}
                    className={classes.dish}
                    onClick={() => handleClickCard(item?.uid)}
                  >
                    <Box
                      className={classes.imgSection}
                      p={{
                        xs: pageType === 'story' ? '0px' : '15px',
                        md: pageType === 'story' ? '0px' : '25px',
                      }}
                      bgcolor={
                        pageType === 'story'
                          ? 'transparent'
                          : variation === SECOND_VARIATION
                          ? 'turmeric.main'
                          : 'cinnamon.main'
                      }
                    >
                      <Box
                        className={classes.imgWrapper}
                        height={{
                          xs: pageType === 'story' ? '280px' : '230px',
                          md: pageType === 'story' ? '325px' : '275px',
                        }}
                        width={{
                          xs: pageType === 'story' ? '280px' : '230px',
                          md: pageType === 'story' ? '325px' : '275px',
                        }}
                      >
                        <Image
                          src={dish_image?.url}
                          alt={dish_image?.alt || dish_name}
                          objectFit="cover"
                          layout="fill"
                        />
                      </Box>
                    </Box>
                    <Box className={classes.textWrapper}>
                      <Typography
                        variant="body2"
                        align="center"
                        color="cumin.main"
                      >
                        {pageType === 'story' ? 'Culture' : 'Recipe'}
                      </Typography>
                      <CircleRoundedIcon
                        sx={{ color: 'cinnamon.main', fontSize: '10px' }}
                      />
                      <Typography
                        variant="body2"
                        align="left"
                        color="cumin.main"
                      >
                        {by_whom}
                      </Typography>
                    </Box>
                    <Typography
                      variant="body1"
                      align="center"
                      color="cinnamon.main"
                      maxWidth="330px"
                    >
                      {dish_name}
                    </Typography>
                  </Box>
                );
              }
            })}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default ReceipesComponent;
